import React from 'react';
import { ThemeProvider } from 'styled-components';
import * as theme from './default';

/* @ts-expect-error - TODO: Fix this the next time the file is edited. */
export function DefaultThemeProvider({ children }) {
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
